import React from "react";
import cn from "classnames";
import * as styles from "./MenuItem.module.scss";

function MenuItem({href, title, target, withBadge, isHeadline, children, inHeader}) {

  return (
    <div
      className={cn(
        styles.root,
        withBadge ? styles.withBadge : null,
        withBadge === "new" && styles.newBadge,
        withBadge === "fun" && styles.funBadge,
        inHeader && styles.inHeaderItem,
        title === "Blog" && styles.current
      )}
    >
      {href ? (
        <>
          {title === "Blog" ? (
            <span
              className={cn(isHeadline ? styles.headline : null)}
              title={title}
            >
          {children}
        </span>
          ) : (
            <a
              className={cn(isHeadline ? styles.headline : null)}
              href={href}
              title={title}
              target={target}
            >
              {children}
            </a>
          )}
        </>
      ) : (
        <span
          className={cn(isHeadline ? styles.headline : null)}
          title={title}
        >
          {children}
        </span>
      )}
    </div>
  );
}

export default MenuItem;
